<template>
  <div class="app-container">
    <!-- tab 页签 -->
    <div ref="topBox">
      <el-tabs v-model="activeTab" @tab-click="handleTabClick">
        <el-tab-pane label="公司汇总" name="company"></el-tab-pane>
        <el-tab-pane label="银行汇总" name="bank"></el-tab-pane>
      </el-tabs>
      <!-- 搜索区 -->
      <div class="formBox margbot">
        <el-form :inline="true" :model="searchForm" ref="searchForm" class="demo-form" size="mini">
          <el-form-item label="年份:">
            <el-date-picker
              v-model="searchForm.yearDate"
              type="year"
              format="yyyy"
              value-format="yyyy"
              placeholder="请选择"
              :clearable="false">
            </el-date-picker>
          </el-form-item>
          <div style="display: flex; align-items: center;">
            <div class="searchBtnBox">
              <el-form-item>
                <el-button type="primary" class="allBtn" @click="searchFn">查询</el-button>
                <el-button type="primary" class="allBtn" @click="resetForm">重置</el-button>
                <el-button type="primary" class="allBtn" @click="exportFn">导出</el-button>
              </el-form-item>
            </div>
            <!-- 合计行 -->
            <!-- <div class="sumBox">
              授信金额合计：<span>{{ summaryTotals.creditAmountAll || '0.00' }}</span> 万元， 贷款金额合计：<span>{{ summaryTotals.loanAmountAll || '0.00' }}</span> 万元， 未用授信金额合计：<span>{{ summaryTotals.unUseCreditAmountAll || '0.00' }}</span> 万元
            </div> -->
          </div>
        </el-form>
      </div>
    </div>

    <!-- 表格 -->
    <div class="table" :style="{ height: h }">
      <el-table :data="tableList" ref="table" :max-height="h" class="tableComent" border show-summary :summary-method="getSummary" v-loading="loading">
        <el-table-column type="index" width="55" label="序号"></el-table-column>
        <el-table-column :label="mainColLabel" :prop="mainNameProp" show-overflow-tooltip></el-table-column>
        <el-table-column label="授信金额(万元)" show-overflow-tooltip>
          <template slot-scope="scope">
            <el-button type="text" @click="openDetail('credit', scope.row)">{{ scope.row.creditAmount }}</el-button>
          </template>
        </el-table-column>
        <el-table-column label="贷款金额(万元)" show-overflow-tooltip>
          <template slot-scope="scope">
            <el-button type="text" @click="openDetail('loan', scope.row)">{{ scope.row.loanAmount }}</el-button>
          </template>
        </el-table-column>
        <el-table-column prop="unUseCreditAmount" label="未用金额(万元)" show-overflow-tooltip></el-table-column>
        <el-table-column prop="remark" label="说明" show-overflow-tooltip></el-table-column>
        <el-table-column prop="legalPerson" label="法人" show-overflow-tooltip></el-table-column>
      </el-table>
    </div>
    <!-- 授信金额 / 贷款金额 明细弹框 -->
    <el-dialog :title="detailTitle" :visible.sync="detailVisible" :close-on-click-modal="false" :close-on-press-escape="false" center width="1100px" @close="closeDetail">
      <el-table :data="detailList" height="420" border v-loading="detailLoading" :row-class-name="detailRowClassName">
        <el-table-column type="index" width="50" label="序号"></el-table-column>
        <el-table-column v-for="col in detailColumns" :key="col.prop" :label="col.label" :prop="col.prop" :formatter="col.formatter" :width="col.width" show-overflow-tooltip></el-table-column>
      </el-table>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" size="mini" @click="detailVisible = false">关 闭</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import {
  findCompanySummaryReport,
  findBankSummaryReport,
  findCreditReport,
  findLoanReport
} from '@/api/common-signature'
import { dateFormat, toFixed } from '@/utils/util'
import { exportExcel } from '@/utils/fileDownXlsx.js'
import global from '@/api/global'

export default {
  name: 'CreditSummary',
  data () {
    return {
      dateFormat: dateFormat,
      activeTab: 'company',
      searchForm: {
        yearDate: new Date().getFullYear() + ''
      },
      tableList: [],
      loading: false,
      summaryObj: null,
      h: '500px',
      // 明细弹框
      detailVisible: false,
      detailType: 'credit',
      detailList: [],
      detailLoading: false
    }
  },
  computed: {
    mainColLabel () {
      return this.activeTab === 'company' ? '公司名称' : '银行名称'
    },
    mainNameProp () {
      return this.activeTab === 'company' ? 'companyName' : 'bankName'
    },
    summaryTotals () {
      return this.summaryObj || {}
    },
    detailTitle () {
      const who = this.activeTab === 'company' ? '公司' : '银行'
      const what = this.detailType === 'credit' ? '授信金额明细' : '贷款金额明细'
      return who + '-' + what
    },
    detailColumns () {
      const primaryLabel = this.activeTab === 'company' ? '银行名称' : '公司名称'
      const primaryProp = this.activeTab === 'company' ? 'bankName' : 'companyName'
      const base = [{ label: primaryLabel, prop: primaryProp, width: 220 }]
      if (this.detailType === 'credit') {
        return base.concat([
          { label: '授信金额(万元)', prop: 'creditAmount', width: 120 },
          { label: '已贷金额(万元)', prop: 'loanAmount', width: 120 },
          { label: '未用金额(万元)', prop: 'unUseCreditAmount', width: 120 },
          { label: '授信到期日', prop: 'creditExpireDate', formatter: this.dateFormat, width: 130 },
          { label: '担保方式', prop: 'securityTypeName', width: 120 },
          { label: '担保人', prop: 'securityUser', width: 100 },
          { label: '是否上征信', prop: 'isCredit', formatter: this.isCreditFormat, width: 100 },
          { label: '授信年限', prop: 'creditLife', width: 100 },
          { label: '抵押年限', prop: 'hockLife', width: 100 },
          { label: '授信方式', prop: 'creditMode', width: 100 },
          { label: '法人', prop: 'legalPerson', width: 100 }
        ])
      }
      return base.concat([
        { label: '放款日期', prop: 'putDate', formatter: this.dateFormat, width: 130 },
        { label: '还款日期', prop: 'backDate', formatter: this.dateFormat, width: 130 },
        { label: '贷款金额(万元)', prop: 'loanAmount', width: 120 },
        { label: '已还金额(万元)', prop: 'backAmount', width: 120 },
        { label: '利率', prop: 'loanRate', width: 100 },
        { label: '贷款年限', prop: 'loanLife', width: 100 },
        { label: '贷款方案', prop: 'loanPlan', width: 120 },
        { label: '还贷款利息日期', prop: 'back_interestDate', width: 160 }
      ])
    }
  },
  created () {
    this.getList()
  },
  mounted () {
    const topH = this.$refs.topBox ? this.$refs.topBox.offsetHeight : 120
    const pH = document.documentElement.clientHeight
    this.h = (pH - topH - 170) + 'px'
  },
  methods: {
    sumNum (data, key) {
      if (!Array.isArray(data)) return 0
      return data.reduce((s, r) => {
        const v = Number(String(r[key] == null ? '' : r[key]).replace(/,/g, ''))
        return s + (isNaN(v) ? 0 : v)
      }, 0)
    },
    isCreditFormat (row, col, val) {
      if (val === 1 || val === '1') return '上'
      if (val === 0 || val === '0') return '不上'
      return val == null ? '' : val
    },
    getList () {
      this.loading = true
      const params = {
        yearDate: this.searchForm.yearDate
      }
      const api = this.activeTab === 'company' ? findCompanySummaryReport : findBankSummaryReport
      api(params).then(res => {
        this.loading = false
        const resp = (res && res.data) ? res.data : (res || {})
        this.tableList = resp.list || []
        this.summaryObj = resp || null
      }).catch(err => {
        this.loading = false
        this.$message.error((err && (err.message || err.msg)) || '查询失败')
      })
    },
    searchFn () {
      if (!this.searchForm.yearDate) {
        this.$message.warning('请选择年份')
        return
      }
      this.getList()
    },
    resetForm () {
      this.searchForm = {
        yearDate: new Date().getFullYear() + ''
      }
      this.getList()
    },
    exportFn () {
      const url = global.smpName + (this.activeTab === 'company'
        ? '/credit/exportCompanySummaryReport'
        : '/credit/exportBankSummaryReport')
      const name = this.activeTab === 'company' ? '公司授信汇总' : '银行授信汇总'
      exportExcel(url, { yearDate: this.searchForm.yearDate }, name)
    },
    handleTabClick () {
      this.getList()
    },
    // 点击授信金额 / 贷款金额 -> 弹框
    openDetail (type, row) {
      this.detailType = type
      this.detailVisible = true
      this.detailLoading = true
      this.detailList = []
      const api = type === 'credit' ? findCreditReport : findLoanReport
      let ids = ''
      if (type === 'credit') {
      // row.ids 为后端返回的字符串（逗号分隔），转成数组传给接口
        ids = row.ids
          ? String(row.ids).split(',').map(s => s.trim()).filter(Boolean)
          : []
      } else {
        ids = row.ids
      }
      api({ ids }).then(res => {
        this.detailLoading = false
        const resp = (res && res.data) ? res.data : (res || {})
        const data = Array.isArray(resp.list) ? resp.list : (Array.isArray(resp) ? resp : [])
        data.forEach(item => {
          let shouxin = item.creditAmount ? item.creditAmount : 0
          let yidai = item.loanAmount ? item.loanAmount : 0
          item.unUseCreditAmount = toFixed(shouxin - yidai, 2)
        })
        // 拼最后一行合计（字体加粗蓝由 detailRowClassName 控制）
        if (data.length) {
          const totalRow = { isTotal: true, companyName: '合计', bankName: '合计' }
          if (type === 'credit') {
            // 优先取后端合计；后端未返回时按明细行求和兜底（授信金额 / 已贷金额 / 未用 = 授信 - 已贷）
            const creditSum = this.sumNum(data, 'creditAmount')
            const loanSum = this.sumNum(data, 'loanAmount')
            totalRow.creditAmount = resp.creditAmountAll != null ? resp.creditAmountAll : toFixed(creditSum, 2)
            totalRow.loanAmount = resp.loanAmountAll != null ? resp.loanAmountAll : toFixed(loanSum, 2)
            totalRow.unUseCreditAmount = resp.unUseCreditAmountAll != null
              ? resp.unUseCreditAmountAll
              : toFixed(creditSum - loanSum, 2)
          } else {
            // 贷款明细合计取后端返回；未返回则回退为明细行求和
            totalRow.loanAmount = resp.loanAmountAll != null ? resp.loanAmountAll : toFixed(this.sumNum(data, 'loanAmount'), 2)
            totalRow.backAmount = resp.backAmountAll != null ? resp.backAmountAll : toFixed(this.sumNum(data, 'backAmount'), 2)
          }
          data.push(totalRow)
        }
        this.detailList = data
      }).catch(err => {
        this.detailLoading = false
        this.$message.error((err && (err.message || err.msg)) || '查询明细失败')
      })
    },
    closeDetail () {
      this.detailList = []
    },
    // 明细弹框合计行样式
    detailRowClassName ({ row }) {
      if (row && row.isTotal) return 'total-row'
      return ''
    },
    // 主表合计行（直接取后端返回的汇总字段，页脚固定在表格底部）
    getSummary ({ columns }) {
      const sums = []
      const s = this.summaryObj || {}
      const val = (v) => (v != null && v !== '') ? v : '0.00'
      columns.forEach((col, index) => {
        if (index === 0) { sums[index] = '合计'; return }
        if (col.label.indexOf('授信金额') > -1) sums[index] = val(s.creditAmountAll)
        else if (col.label.indexOf('贷款金额') > -1) sums[index] = val(s.loanAmountAll)
        else if (col.label.indexOf('未用金额') > -1) sums[index] = val(s.unUseCreditAmountAll)
        else sums[index] = ''
      })
      return sums
    },
    // 明细弹框合计行
    detailSummary ({ columns, data }) {
      const sums = []
      columns.forEach((col, index) => {
        if (index === 0) { sums[index] = '合计'; return }
        const prop = col.property
        if (prop && data.length) {
          sums[index] = this.sumNum(data, prop)
        } else {
          sums[index] = ''
        }
      })
      return sums
    }
  }
}
</script>

<style scoped lang="less">
.searchBtnBox {
  margin-left: 10px;
}
.sumBox {
  padding: 10px 0;
  font-size: 14px;
  color: #333;
  span {
    color: #F56C6C;
    font-weight: bold;
    font-size: 14px;
  }
}
/deep/.el-tabs__header{
  margin: 0;
}
/deep/.total-row {
  font-weight: bold;
  color: #409EFF;
}
// 主表底部原生合计行（show-summary）：加粗蓝色
/deep/.tableComent .el-table__footer .cell {
  color: #409EFF;
  font-weight: bold;
}
</style>
